import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import RenovationFilterBar from "../components/RenovationFilterBar";
import RenovationListings from "../components/RenovationListings";
import Header from "../components/Header";

export default function RenovationPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [filter, setFilter] = useState({});

  return (
    <div className="renovation-page">

      {/* =========================
          HERO
      ========================== */}

      <div
        className="renovation-hero"
        style={{
          backgroundImage: `url("/images/renov111.jpg")`,
        }}
      >
        {/* Dark overlay */}
        <div className="renovation-hero-overlay" />

        <Header section="renovation" />

        <div className="renovation-hero-content">

          <h1>
             {t("renovation.pageTitle")}
          </h1>

          <p>
            {t("renovation.pageSubtitle")}
          </p>

        </div>

        {/* =========================
            FILTERS
        ========================== */}

        <div className="renovation-filters">
          <RenovationFilterBar
            filter={filter}
            setFilter={setFilter}
          />
        </div>

      </div>

      {/* =========================
          LISTINGS
      ========================== */}

      <div className="renovation-content">

        <RenovationListings
          filter={filter}
        />

      </div>

    </div>
  );
}
